module.exports = __webpack_public_path__ + "img/首页2-4-hover.12f48ac4.svg";